/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_4_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workbook is too awkward on a phone`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_4_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手机上操作不方便`)
};

/**
* | output |
* | --- |
* | "The workbook is too awkward on a phone" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_4_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_4_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_4_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_4_0 as "gc.search_guides.gridcraft_online.sections.3.table.rows.4.0" }